import styled from "@emotion/styled";
import DisplayType from "utils/displayType";
import DefaultButton from "admin/component/button/DefaultButton";
import { useLayoutEffect } from "react";
import { updateTitle } from "utils/commonUtil";
import { useLanguage } from "i18n/LanguageContext";
import { renderText } from "i18n/TranslatedText";
import Footer from "../../component/footer/Footer";
import { ReactComponent as Logo } from "../../assets/logo_alumni.svg";
import logo from "../../assets/logo_alumni.jpg";

const Alumni = () => {
  const mode = DisplayType();
  const { t } = useLanguage();

  useLayoutEffect(() => {
    updateTitle(t("program", "alumni.pageTitle"));
  }, [t]);

  return (
    <Container>
      <HeaderContainer>
        {/* <Logo className="program__logo" /> */}
        <img className="program__logo" src={logo} alt="프로그램 로고" />
        <span
          className={`program__title ${
            mode === "Mobile" ? "font-bold-24" : "font-title"
          }`}
        >
          {t("program", "alumni.title")}
        </span>
        <p
          className={`program__description ${
            mode === "Mobile" ? "font-body3" : "font-body2"
          }`}
        >
          {renderText(t("program", "alumni.desc"), mode)}
        </p>
      </HeaderContainer>
      <BodyContainer className="limit__body">
        <ProgramDescription>
          <div
            className={`program__description__title ${
              mode === "Mobile" ? "font-sub-title2" : "font-title"
            }`}
          >
            {t("program", "alumni.descTitle")}
          </div>
          <p className={`${mode === "Mobile" ? "font-body3" : "font-body2"}`}>
            {t("program", "alumni.descBody1")} <br />
            <br />
            {t("program", "alumni.descBody2")}
          </p>
        </ProgramDescription>
        <ProgramProcess>
          <div
            className={`program__process__title ${
              mode === "Mobile" ? "font-bold-22" : "font-sub-title"
            }`}
          >
            {t("program", "alumni.processTitle")}
          </div>
          <div className={`program__process__row`}>
            <span
              className={`${
                mode === "Mobile" ? "font-bold-16" : "font-bold-18"
              }`}
            >
              {t("program", "alumni.descLabel")}
            </span>
            <span
              className={`${mode === "Mobile" ? "font-body3" : "font-body2"}`}
            >
              {t("program", "alumni.descValue")}
            </span>
          </div>
          <div className={`program__process__row`} style={{ marginTop: 8 }}>
            <span
              className={`${
                mode === "Mobile" ? "font-bold-16" : "font-bold-18"
              }`}
            >
              {t("program", "alumni.targetLabel")}
            </span>
            <span
              className={`${mode === "Mobile" ? "font-body3" : "font-body2"}`}
            >
              {t("program", "alumni.targetValue")}
            </span>
          </div>
          <div className="program__process__list">
            <ProgramProcessItem>
              <div className="program__process__item__column">
                <span
                  className={`${
                    mode === "Mobile" ? "font-sub-title2" : "font-sub-title"
                  }`}
                  style={{ color: "var(--primary)" }}
                >
                  Step. 1
                </span>
                <span
                  className={`${
                    mode === "Mobile" ? "font-body3" : "font-body2"
                  }`}
                  style={{ color: "var(--primary)" }}
                >
                  {t("program", "alumni.step1Duration")}
                </span>
              </div>
              <div className="program__process__item__column">
                <span
                  className={`item__title ${
                    mode === "Mobile" ? "font-body3" : "font-body2"
                  }`}
                >
                  {t("program", "alumni.step1Title")}
                </span>
                <span
                  className={`item__descrition ${
                    mode === "Mobile" ? "font-body3" : "font-body2"
                  }`}
                >
                  {t("program", "alumni.step1Desc")}
                </span>
              </div>
            </ProgramProcessItem>

            <ProgramProcessItem>
              <div className="program__process__item__column">
                <span
                  className={`${
                    mode === "Mobile" ? "font-sub-title2" : "font-sub-title"
                  }`}
                  style={{ color: "var(--primary)" }}
                >
                  Step. 2
                </span>
                <span
                  className={`${
                    mode === "Mobile" ? "font-body3" : "font-body2"
                  }`}
                  style={{ color: "var(--primary)" }}
                >
                  {t("program", "alumni.step2Duration")}
                </span>
              </div>
              <div className="program__process__item__column">
                <span
                  className={`item__title ${
                    mode === "Mobile" ? "font-body3" : "font-body2"
                  }`}
                >
                  {t("program", "alumni.step2Title")}
                </span>
              </div>
            </ProgramProcessItem>

            <ProgramProcessItem>
              <div className="program__process__item__column">
                <span
                  className={`${
                    mode === "Mobile" ? "font-sub-title2" : "font-sub-title"
                  }`}
                  style={{ color: "var(--primary)" }}
                >
                  Step. 3
                </span>
                <span
                  className={`${
                    mode === "Mobile" ? "font-body3" : "font-body2"
                  }`}
                  style={{ color: "var(--primary)" }}
                >
                  {t("program", "alumni.step3Duration")}
                </span>
              </div>
              <div className="program__process__item__column">
                <span
                  className={`item__title ${
                    mode === "Mobile" ? "font-body3" : "font-body2"
                  }`}
                >
                  {t("program", "alumni.step3Title")}
                </span>
                <span
                  className={`item__descrition ${
                    mode === "Mobile" ? "font-body3" : "font-body2"
                  }`}
                >
                  {t("program", "alumni.step3Desc")}
                </span>
              </div>
            </ProgramProcessItem>

            <ProgramProcessItem>
              <div className="program__process__item__column">
                <span
                  className={`${
                    mode === "Mobile" ? "font-sub-title2" : "font-sub-title"
                  }`}
                  style={{ color: "var(--primary)" }}
                >
                  Step. 4
                </span>
                <span
                  className={`${
                    mode === "Mobile" ? "font-body3" : "font-body2"
                  }`}
                  style={{ color: "var(--primary)" }}
                >
                  {t("program", "alumni.step4Duration")}
                </span>
              </div>
              <div className="program__process__item__column">
                <span
                  className={`item__title ${
                    mode === "Mobile" ? "font-body3" : "font-body2"
                  }`}
                >
                  {t("program", "alumni.step4Title")}
                </span>
              </div>
            </ProgramProcessItem>

            <ProgramProcessItem>
              <div className="program__process__item__column">
                <span
                  className={`${
                    mode === "Mobile" ? "font-sub-title2" : "font-sub-title"
                  }`}
                  style={{ color: "var(--primary)" }}
                >
                  Step. 5
                </span>
                <span
                  className={`${
                    mode === "Mobile" ? "font-body3" : "font-body2"
                  }`}
                  style={{ color: "var(--primary)" }}
                >
                  {t("program", "alumni.step5Duration")}
                </span>
              </div>
              <div className="program__process__item__column">
                <span
                  className={`item__title ${
                    mode === "Mobile" ? "font-body3" : "font-body2"
                  }`}
                >
                  {t("program", "alumni.step5Title")}
                </span>
                <span
                  className={`item__descrition ${
                    mode === "Mobile" ? "font-body3" : "font-body2"
                  }`}
                >
                  {t("program", "alumni.step5Desc")}
                </span>
              </div>
            </ProgramProcessItem>
          </div>
        </ProgramProcess>
        <ProgramProcess>
          <div
            className={`program__process__title ${
              mode === "Mobile" ? "font-bold-22" : "font-sub-title"
            }`}
          >
            {t("program", "alumni.contactTitle")}
          </div>
          <div
            className={`item__descrition ${
              mode === "Mobile" ? "font-body3" : "font-body2"
            }`}
            style={{ marginBottom: mode === "Mobile" ? 24 : 16 }}
          >
            {t("program", "alumni.contactNotice")}
          </div>
          <a
            href="https://www.dongchang.blue/"
            target={"_blank"}
            style={{ textDecoration: "none" }}
            rel="noreferrer"
          >
            <DefaultButton
              className="font-body3"
              type="outline"
              width={190}
              height={42}
              isHover
            >
              {t("program", "alumni.websiteButton")}
            </DefaultButton>
          </a>
        </ProgramProcess>
      </BodyContainer>
      <Footer />
    </Container>
  );
};
const Container = styled.div`
  width: 100%;
  height: 100%;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  padding-top: 80px;

  @media only screen and (max-width: 768px) {
    padding-top: 60px;
  }
`;

const HeaderContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: var(--bg-02);
  padding-top: 80px;
  padding-bottom: 80px;

  .program__logo {
    width: 240px;
    min-width: 240px;
    max-width: 240px;
    height: 240px;
    min-width: 240px;
    max-width: 240px;
    border-radius: 50%;
    border: 1px solid #e5e5ea;

    -webkit-user-drag: none;
    user-select: none;
    -moz-user-select: none;
    -webkit-user-select: none;
    -ms-user-select: none;
  }
  .program__title {
    color: var(--black);
    margin-top: 24px;
    margin-bottom: 16px;
  }
  .program__description {
    color: var(--grey-40);
    text-align: center;
  }

  @media only screen and (max-width: 768px) {
    padding-bottom: 60px;
    .program__logo {
      width: 117px;
      min-width: 117px;
      max-width: 117px;
      height: 117px;
      min-width: 117px;
      max-width: 117px;
    }
    .program__title {
      color: var(--black);
      margin-top: 24px;
      margin-bottom: 8px;
    }
  }
`;

const BodyContainer = styled.div`
  width: 100%;
  flex-grow: 1;
  display: flex;
  flex-direction: column;

  margin-bottom: 160px;
`;

const ProgramDescription = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;

  margin-top: 100px;

  .program__description__title {
    color: var(--primary);
    margin-bottom: 24px;
  }

  @media only screen and (max-width: 768px) {
    margin-top: 40px;
    .program__description__title {
      margin-bottom: 16px;
    }
  }
`;

const ProgramProcess = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;

  margin-top: 100px;

  .program__process__title {
    color: var(--black);
    margin-bottom: 24px;
  }

  .program__process__row {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 16px;
  }

  .program__process__list {
    width: 100%;
    border-top: 1px solid var(--grey-00);
    display: flex;
    flex-direction: column;
    margin-top: 24px;
  }
  @media only screen and (max-width: 768px) {
    margin-top: 40px;
    .program__process__title {
      margin-bottom: 16px;
    }
    .program__process__row {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      gap: 4px;
    }
  }
`;

const ProgramProcessItem = styled.div`
  width: 100%;
  padding: 32px;
  display: flex;
  flex-direction: row;
  border-bottom: 1px solid var(--grey-00);
  gap: 312px;
  .program__process__item__column {
    display: flex;
    flex-direction: column;
    min-width: 100px;
  }
  .item__title {
    color: var(--primary);
  }
  .item__descrition {
    color: var(--grey-60);
  }
  @media only screen and (max-width: 768px) {
    flex-direction: column;
    gap: 8px;
    padding: 24px 16px;
  }
`;

const EmailContainer = styled.div`
  margin-top: 16px;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  .email__icon {
    width: 32px;
    height: 32px;
  }
  .email__text {
    color: var(--primary);
  }
`;
export default Alumni;
